/*eslint react-hooks/exhaustive-deps: "off"*/
import React, { useEffect, useRef, useState } from "react";

// TODO: ChartPane 생명주기와 함께 rMateChartH5 객체를 유지하기.

const ChartPane = ({
  data,
  processor,
  layoutProcessor,
  style,
  onlyLayoutChange = false,
  layoutParam = {},
}) => {
  const [prevData, setPrevData] = useState();
  const [prevLayout, setPrevLayout] = useState({});
  const randomIdRef = useRef(
    (Math.random() * 0x10000).toString(16).replace(".", "_")
  );
  const divId = "div_" + String(randomIdRef.current);
  const chartId = "rMateChart_" + String(randomIdRef.current);

  const chartDestroy = () => {
    const chart = document.getElementById(chartId);
    if (chart) chart.destroy();
  };

  useEffect(() => {
    if (processor && layoutProcessor) {
      const processedData = processor(data);

      if (
        processedData &&
        (JSON.stringify(prevData) !== JSON.stringify(processedData) ||
          JSON.stringify(prevData).length !==
            JSON.stringify(processedData).length)
      ) {
        const layoutStr = layoutProcessor();
        window[`chartReadyHandler_${divId}`] = () => {
          document.getElementById(chartId).setLayout(layoutStr);
          document.getElementById(chartId).setData(processedData);
        };
        const chartVars = `rMateOnLoadCallFunction=chartReadyHandler_${divId}`;
        chartDestroy();
        window.rMateChartH5.create(chartId, divId, chartVars);

        setPrevData(JSON.parse(JSON.stringify(processedData)));
      } else if (
        processedData &&
        (JSON.stringify(prevData) !== JSON.stringify(processedData) ||
          JSON.stringify(prevData).length !==
            JSON.stringify(processedData).length) &&
        onlyLayoutChange &&
        JSON.stringify(prevLayout) !== JSON.stringify(layoutParam)
      ) {
        const layoutStr = layoutProcessor();
        window[`chartReadyHandler_${divId}`] = () => {
          document.getElementById(chartId).setLayout(layoutStr);
          document.getElementById(chartId).setData(processedData);
        };
        const chartVars = `rMateOnLoadCallFunction=chartReadyHandler_${divId}`;
        chartDestroy();
        window.rMateChartH5.create(chartId, divId, chartVars);

        setPrevData(JSON.parse(JSON.stringify(processedData)));
        setPrevLayout(layoutParam);
      } else {
        const chart = document.getElementById(chartId);
        if (chart) chart.resize();
      }
    }
  }, [processor, layoutProcessor, data]);

  return <div id={divId} style={{ width: "100%", height: 800, ...style }} />;
};

export default ChartPane;
